import { render } from "./SocialSection.vue?vue&type=template&id=7703ed37&scoped=true"
import script from "./SocialSection.vue?vue&type=script&lang=js"
export * from "./SocialSection.vue?vue&type=script&lang=js"

import "./SocialSection.vue?vue&type=style&index=0&id=7703ed37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7703ed37"]])

export default __exports__